import React from 'react';
import { Dashboard } from './Dashboard';

/**
 * Página principal del Dashboard Ejecutivo
 * Envuelve el componente Dashboard para mantener consistencia con la estructura del proyecto
 */
export const DashboardPage: React.FC = () => {
  return <Dashboard />;
};